import { Component, OnInit, Inject, ChangeDetectionStrategy} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogPrThresholdExceededGridLayoutService } from '@irb/irb-dialogs/dialog-pr-threshold-exceeded/dialg-pr-threshold-exceeded.grid-layout.service';
import { IThresholdExceededPortfolio } from '@irb/irb-editors/editor-portfolio-result/editor-portfolio-result.model';

@Component({ standalone: false,
  selector: 'irb-dialog-pr-threshold-exceeded',
  templateUrl: './dialog-pr-threshold-exceeded.component.html',
  styleUrls: ['./dialog-pr-threshold-exceeded.component.scss','../../irb-common/styles/dialog.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class DialogPrThresholdExceededComponent implements OnInit {
  portfolios: Array<IThresholdExceededPortfolio> = [];
  uniquePortfolios: Array<IThresholdExceededPortfolio> = [];
  grid: any;
  gridOptions: any;
  frameworkComponents: any;

  constructor(
    public dialogRef: MatDialogRef<DialogPrThresholdExceededComponent>,
    @Inject(MAT_DIALOG_DATA) public mdd: any,
    private gls: DialogPrThresholdExceededGridLayoutService
  ) { }

  ngOnInit(): void {
    this.gridOptions = {
      columnDefs: this.gls.getColumnDefs(),      
      floatingFilter: false,
      overlayNoRowsTemplate: "<span class='ag-overlay-loading-center ag-overlay-message'>No results.</span>",
      context: { componentParent: this }
    };
    
    this.frameworkComponents = this.gls.getFrameworkComponents();
    this.portfolios = this.mdd.portfolios as Array<IThresholdExceededPortfolio>;
    this.uniquePortfolios = this.portfolios.filter((value, index, self) => self.map(x => x.portfolioName).indexOf(value.portfolioName) == index);
  }

  close() {
    this.dialogRef.close();
  }

  proceed() {
    this.mdd.callBack();
    this.dialogRef.close();
  }

  onGridReady(params: any) {
    this.grid = params;
  }
}
